export const FETCH_PERSONNEL_COUNTRY_LIST_END = "fetchPersonnelCountryListEnd";
